import { useContext, useEffect, useMemo, useState } from "react";
import { ContextGlobal } from "../../../../context";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, defaultValues } from "./schema";
import { handleMessageError, handleMessageSuccess, handleMessageWarning } from "../../../../components/toast";
import LibBoolean from "../../../../util/libBool";
import LibDateTime from "../../../../util/libDateTime";
import { id } from "date-fns/locale";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	reloadFetchFirstData,
	insert,
}) => {
	// todo -- trocar ativo por pago e pendente - colocar um select com essas opções pago pedente cancelado
	// todo -- quando estiver alterando permitir alterar na grid de parcelas o valor da parcela

	//#region useForm
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		watch,
		getValues,
		// setError,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: defaultValues,
	});
	//#endregion

	//#region ContextGlobal e Fetch de dados
	const {
		categoryData,
		fetchCategory,

		bankData,
		fetchBank,

		costCenterData,
		fetchCostCenter,

		formPaymentData,
		fetchFormPayment,
	} = useContext(ContextGlobal);

	useEffect(() => {
		if (categoryData.length === 0) fetchCategory();
		if (bankData.length === 0) fetchBank();
		if (costCenterData.length === 0) fetchCostCenter();
		if (formPaymentData.length === 0) fetchFormPayment();
	}, []);
	//#endregion

	//#region Variaveis de controle
	const [isInsert, setIsInsert] = useState(false); //se é insert ou update
	const [loading, setLoading] = useState(false);

	const [installments, setInstallment] = useState([]); //variavel de controle das parcelas
	const parcelas = watch("parcelas"); //array de parcelas do form que esta no schema
	const valorTotal = watch("valor"); //valor total do form
	//#endregion

	//#region useEffect para atualizar o valor  da primeira parcela na tabela
	useEffect(() => {
		if (installments.length > 0) {
			const primeiraParcela = {
				...installments[0],
				valor: valorTotal,
			};

			// Atualiza o formulário apenas com a primeira parcela
			setValue("parcelas", [primeiraParcela], { shouldValidate: true });

			// Atualiza o estado com apenas a primeira parcela
			setInstallment([primeiraParcela]);
		}
		// if (installments.length > 0) {
		// 	// 		// setValue(`parcelas.0.valor`, valorTotal, { shouldValidate: true });
		// 	setValue(`parcelas.0.valor`, valorTotal, { shouldValidate: true });
		// 	setInstallment((prev) => {
		// 		prev[0].valor = valorTotal;
		// 		return prev;
		// 	});
		// }
	}, [valorTotal]);
	//#endregion

	//#region Fetch para popular formulário
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetch(id);
			} else {
				//lança o schema com o objeto de parcelas zeradas
				//o parcelas é um watch de parcelas
				setInstallment(parcelas);
			}

			setIsInsert(id === 0);
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = response.data;

				const newData = await processNewData(data);

				Object.keys(newData).forEach((field) => {
					setValue(field, newData[field]);
				});

				if (newData.fantasia) setValue("nome_fornecedor", newData.fantasia);
				else if (newData.nome) setValue("nome_fornecedor", newData.nome);
				else if (newData.fornecedor) setValue("nome_fornecedor", newData.fornecedor);

				const newInstallments = [];
				newInstallments.push({
					id: newData.id_conta_saida,
					id_conta: newData.id_conta,
					id_conta_saida: newData.id_conta_saida,
					parcela: newData.parcela,
					parcela_total: newData.parcela_total,
					data_vencimento: new Date(newData.data).toISOString().split("T")[0],
					// data_vencimento: newData.data,
					// forma_pagamento: 'DINHEIRO',
					id_forma: newData.id_forma,
					valor: newData.valor,
					ativo: newData.ativo,
				});

				setInstallment(newInstallments); //seta as parcelas na variavel de estado
				setValue("parcelas", newInstallments); //seta as parcelas no array do form
			}
		} catch (error) {
			handleMessageError(error);
			handleCloseModalRegister();
		} finally {
			setLoading(false);
		}
	};

	const processNewData = async (data) => {
		const newDate = LibDateTime.formatedUtcToZonedTime(data.data);

		const parc = `${data.parcela}/${data.parcela_total}`;

		return {
			...data,
			ativo: LibBoolean.strToBoolean(data.ativo),
			data: newDate,
			parc,
		};
	};

	//#endregion
	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			const newDate = ValidateSubmit(data);

			const response = await insert(newDate);

			let oldID = 0;
			let currentId = 0;

			//update
			if (newDate.id_conta_saidagrupo !== 0) {
				const returnUpdated = getReturnUpdated(response);
				currentId = returnUpdated[idTable];
				oldID = currentId;
				await reloadData(oldID, currentId);
			} else {
				//insert
				const returnUpdated = getReturnUpdated(response);
				currentId = returnUpdated.id_conta_saidagrupo;
				await reloadFetchFirstData(oldID, currentId);
			}

			handleMessageSuccess("Registro salvo com sucesso.");

			reset();
			handleCloseModalRegister();
		} catch (error) {
			// if (error.field && error.field !== "ID_FORMA") {
			// 	// errosAfterPost(error.field, error.message);
			// }
			handleMessageWarning("Não foi possível salvar, " + error.message);
		}
	};

	const ValidateSubmit = (data) => {
		// const newAtivo = LibBoolean.booleanToStr(data.ativo);
		// const newDate = data.data.toLocaleString("pt-BR");

		const newData = {
			...data,
			// ativo: data.ativo === "SIM" ? "NÃO" : "SIM",
			parcelas: data.parcelas.map((parcela) => ({
				...parcela,
				ativo: parcela.ativo ? "SIM" : "NAO", // Alterna entre `true` e `false`
			})),
		};

		return newData;
	};

	const getReturnUpdated = (response) => {
		if (Array.isArray(response.data)) {
			return response.data[0];
		} else if (typeof response.data === "object") {
			return response.data;
		} else {
			throw new Error("Formato do retorno inválido.");
		}
	};

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	//#endregion

	//#region componente de parcelas para

	const identModalInstallment = "intallmentsModal";

	const handleOpenModalinstallment = (e) => {
		if (valorTotal > 0) {
			e.preventDefault();
			const event = new CustomEvent(identModalInstallment);
			window.dispatchEvent(event);
		} else handleMessageWarning("Informe o valor total da saída antes de continuar.");
	};

	const handleCloseModalinstallment = () => {
		const event = new CustomEvent(identModalInstallment);
		window.dispatchEvent(event);
	};

	const CallBackInstallments = (data) => {
		const newData = data.parcelas.map((parcela) => ({
			...parcela,
			id_conta_saida: 0,
		}));

		setInstallment(newData);
		setValue("parcelas", newData, { shouldValidate: true });
		handleCloseModalinstallment();
	};
	//#endregion

	const filteredCategoryData = useMemo(() => {
		return categoryData.filter((item) => item.tipo?.trim().toUpperCase() === "S");
	}, [categoryData]);

	return {
		//useForm
		register,
		control,
		errors,
		isSubmitting,

		setValue,

		handleSubmit,

		//Data
		categoryData: filteredCategoryData,
		bankData,
		costCenterData,

		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//installments
		identModalInstallment,
		handleOpenModalinstallment,
		handleCloseModalinstallment,
		CallBackInstallments,

		//variables
		installments,
		valorTotal,
		loading,
		isInsert,
	};
};
